/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail portal back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BodyAndAttachments } from '../model';
// @ts-ignore
import type { Mail } from '../model';
// @ts-ignore
import type { Quota } from '../model';
/**
 * WebmailApi - axios parameter creator
 * @export
 */
export const WebmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {WebmailPortalControllerDeleteMessagesFolderEnum} folder 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerDeleteMessages: async (folder: WebmailPortalControllerDeleteMessagesFolderEnum, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerDeleteMessages', 'folder', folder)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('webmailPortalControllerDeleteMessages', 'requestBody', requestBody)
            const localVarPath = `/api/webmail/deleteMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerGetAttachmentFolderEnum} folder 
         * @param {number} uid 
         * @param {number} attachmentIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetAttachment: async (folder: WebmailPortalControllerGetAttachmentFolderEnum, uid: number, attachmentIndex: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerGetAttachment', 'folder', folder)
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('webmailPortalControllerGetAttachment', 'uid', uid)
            // verify required parameter 'attachmentIndex' is not null or undefined
            assertParamExists('webmailPortalControllerGetAttachment', 'attachmentIndex', attachmentIndex)
            const localVarPath = `/api/webmail/getAttachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (attachmentIndex !== undefined) {
                localVarQueryParameter['attachmentIndex'] = attachmentIndex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerGetBodyAndAttachmentsFolderEnum} folder 
         * @param {number} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetBodyAndAttachments: async (folder: WebmailPortalControllerGetBodyAndAttachmentsFolderEnum, uid: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerGetBodyAndAttachments', 'folder', folder)
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('webmailPortalControllerGetBodyAndAttachments', 'uid', uid)
            const localVarPath = `/api/webmail/getBodyAndAttachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMessageCountFolderEnum} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetMessageCount: async (folder: WebmailPortalControllerGetMessageCountFolderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerGetMessageCount', 'folder', folder)
            const localVarPath = `/api/webmail/getMessageCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMessagesFolderEnum} folder 
         * @param {number} start 
         * @param {number} maxNumberOfMessages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetMessages: async (folder: WebmailPortalControllerGetMessagesFolderEnum, start: number, maxNumberOfMessages: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerGetMessages', 'folder', folder)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('webmailPortalControllerGetMessages', 'start', start)
            // verify required parameter 'maxNumberOfMessages' is not null or undefined
            assertParamExists('webmailPortalControllerGetMessages', 'maxNumberOfMessages', maxNumberOfMessages)
            const localVarPath = `/api/webmail/getMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (maxNumberOfMessages !== undefined) {
                localVarQueryParameter['maxNumberOfMessages'] = maxNumberOfMessages;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMimeMessageFolderEnum} folder 
         * @param {number} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetMimeMessage: async (folder: WebmailPortalControllerGetMimeMessageFolderEnum, uid: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerGetMimeMessage', 'folder', folder)
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('webmailPortalControllerGetMimeMessage', 'uid', uid)
            const localVarPath = `/api/webmail/getMimeMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerGetQuotaFolderEnum} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetQuota: async (folder: WebmailPortalControllerGetQuotaFolderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerGetQuota', 'folder', folder)
            const localVarPath = `/api/webmail/getQuota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} recipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerIsRecipientAllowed: async (recipient: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipient' is not null or undefined
            assertParamExists('webmailPortalControllerIsRecipientAllowed', 'recipient', recipient)
            const localVarPath = `/api/webmail/isRecipientAllowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (recipient !== undefined) {
                localVarQueryParameter['recipient'] = recipient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerReplyFolderEnum} folder 
         * @param {number} uid 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerReply: async (folder: WebmailPortalControllerReplyFolderEnum, uid: number, textBody: string, attachments?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerReply', 'folder', folder)
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('webmailPortalControllerReply', 'uid', uid)
            // verify required parameter 'textBody' is not null or undefined
            assertParamExists('webmailPortalControllerReply', 'textBody', textBody)
            const localVarPath = `/api/webmail/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


            if (textBody !== undefined) { 
                localVarFormParams.append('textBody', textBody as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                  localVarFormParams.append('attachments', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subject 
         * @param {Array<string>} recipients 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerSendMail: async (subject: string, recipients: Array<string>, textBody: string, attachments?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('webmailPortalControllerSendMail', 'subject', subject)
            // verify required parameter 'recipients' is not null or undefined
            assertParamExists('webmailPortalControllerSendMail', 'recipients', recipients)
            // verify required parameter 'textBody' is not null or undefined
            assertParamExists('webmailPortalControllerSendMail', 'textBody', textBody)
            const localVarPath = `/api/webmail/sendMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (recipients) {
                localVarQueryParameter['recipients'] = recipients;
            }


            if (textBody !== undefined) { 
                localVarFormParams.append('textBody', textBody as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                  localVarFormParams.append('attachments', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebmailPortalControllerSetReadFlagFolderEnum} folder 
         * @param {boolean} read 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerSetReadFlag: async (folder: WebmailPortalControllerSetReadFlagFolderEnum, read: boolean, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('webmailPortalControllerSetReadFlag', 'folder', folder)
            // verify required parameter 'read' is not null or undefined
            assertParamExists('webmailPortalControllerSetReadFlag', 'read', read)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('webmailPortalControllerSetReadFlag', 'requestBody', requestBody)
            const localVarPath = `/api/webmail/setReadStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (read !== undefined) {
                localVarQueryParameter['read'] = read;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebmailApi - functional programming interface
 * @export
 */
export const WebmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {WebmailPortalControllerDeleteMessagesFolderEnum} folder 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerDeleteMessages(folder: WebmailPortalControllerDeleteMessagesFolderEnum, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerDeleteMessages(folder, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerDeleteMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerGetAttachmentFolderEnum} folder 
         * @param {number} uid 
         * @param {number} attachmentIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerGetAttachment(folder: WebmailPortalControllerGetAttachmentFolderEnum, uid: number, attachmentIndex: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerGetAttachment(folder, uid, attachmentIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerGetAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerGetBodyAndAttachmentsFolderEnum} folder 
         * @param {number} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerGetBodyAndAttachments(folder: WebmailPortalControllerGetBodyAndAttachmentsFolderEnum, uid: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BodyAndAttachments>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerGetBodyAndAttachments(folder, uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerGetBodyAndAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMessageCountFolderEnum} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerGetMessageCount(folder: WebmailPortalControllerGetMessageCountFolderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerGetMessageCount(folder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerGetMessageCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMessagesFolderEnum} folder 
         * @param {number} start 
         * @param {number} maxNumberOfMessages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerGetMessages(folder: WebmailPortalControllerGetMessagesFolderEnum, start: number, maxNumberOfMessages: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerGetMessages(folder, start, maxNumberOfMessages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerGetMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMimeMessageFolderEnum} folder 
         * @param {number} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerGetMimeMessage(folder: WebmailPortalControllerGetMimeMessageFolderEnum, uid: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerGetMimeMessage(folder, uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerGetMimeMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerGetQuotaFolderEnum} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerGetQuota(folder: WebmailPortalControllerGetQuotaFolderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Quota>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerGetQuota(folder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerGetQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} recipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerIsRecipientAllowed(recipient: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerIsRecipientAllowed(recipient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerIsRecipientAllowed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerReplyFolderEnum} folder 
         * @param {number} uid 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerReply(folder: WebmailPortalControllerReplyFolderEnum, uid: number, textBody: string, attachments?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerReply(folder, uid, textBody, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subject 
         * @param {Array<string>} recipients 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerSendMail(subject: string, recipients: Array<string>, textBody: string, attachments?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerSendMail(subject, recipients, textBody, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerSendMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebmailPortalControllerSetReadFlagFolderEnum} folder 
         * @param {boolean} read 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webmailPortalControllerSetReadFlag(folder: WebmailPortalControllerSetReadFlagFolderEnum, read: boolean, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webmailPortalControllerSetReadFlag(folder, read, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebmailApi.webmailPortalControllerSetReadFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebmailApi - factory interface
 * @export
 */
export const WebmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebmailApiFp(configuration)
    return {
        /**
         * 
         * @param {WebmailPortalControllerDeleteMessagesFolderEnum} folder 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerDeleteMessages(folder: WebmailPortalControllerDeleteMessagesFolderEnum, requestBody: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.webmailPortalControllerDeleteMessages(folder, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerGetAttachmentFolderEnum} folder 
         * @param {number} uid 
         * @param {number} attachmentIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetAttachment(folder: WebmailPortalControllerGetAttachmentFolderEnum, uid: number, attachmentIndex: number, options?: any): AxiosPromise<string> {
            return localVarFp.webmailPortalControllerGetAttachment(folder, uid, attachmentIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerGetBodyAndAttachmentsFolderEnum} folder 
         * @param {number} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetBodyAndAttachments(folder: WebmailPortalControllerGetBodyAndAttachmentsFolderEnum, uid: number, options?: any): AxiosPromise<BodyAndAttachments> {
            return localVarFp.webmailPortalControllerGetBodyAndAttachments(folder, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMessageCountFolderEnum} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetMessageCount(folder: WebmailPortalControllerGetMessageCountFolderEnum, options?: any): AxiosPromise<number> {
            return localVarFp.webmailPortalControllerGetMessageCount(folder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMessagesFolderEnum} folder 
         * @param {number} start 
         * @param {number} maxNumberOfMessages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetMessages(folder: WebmailPortalControllerGetMessagesFolderEnum, start: number, maxNumberOfMessages: number, options?: any): AxiosPromise<Array<Mail>> {
            return localVarFp.webmailPortalControllerGetMessages(folder, start, maxNumberOfMessages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerGetMimeMessageFolderEnum} folder 
         * @param {number} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetMimeMessage(folder: WebmailPortalControllerGetMimeMessageFolderEnum, uid: number, options?: any): AxiosPromise<string> {
            return localVarFp.webmailPortalControllerGetMimeMessage(folder, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerGetQuotaFolderEnum} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerGetQuota(folder: WebmailPortalControllerGetQuotaFolderEnum, options?: any): AxiosPromise<Array<Quota>> {
            return localVarFp.webmailPortalControllerGetQuota(folder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} recipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerIsRecipientAllowed(recipient: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.webmailPortalControllerIsRecipientAllowed(recipient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerReplyFolderEnum} folder 
         * @param {number} uid 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerReply(folder: WebmailPortalControllerReplyFolderEnum, uid: number, textBody: string, attachments?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.webmailPortalControllerReply(folder, uid, textBody, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subject 
         * @param {Array<string>} recipients 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerSendMail(subject: string, recipients: Array<string>, textBody: string, attachments?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.webmailPortalControllerSendMail(subject, recipients, textBody, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebmailPortalControllerSetReadFlagFolderEnum} folder 
         * @param {boolean} read 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webmailPortalControllerSetReadFlag(folder: WebmailPortalControllerSetReadFlagFolderEnum, read: boolean, requestBody: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.webmailPortalControllerSetReadFlag(folder, read, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebmailApi - object-oriented interface
 * @export
 * @class WebmailApi
 * @extends {BaseAPI}
 */
export class WebmailApi extends BaseAPI {
    /**
     * 
     * @param {WebmailPortalControllerDeleteMessagesFolderEnum} folder 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerDeleteMessages(folder: WebmailPortalControllerDeleteMessagesFolderEnum, requestBody: Array<number>, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerDeleteMessages(folder, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerGetAttachmentFolderEnum} folder 
     * @param {number} uid 
     * @param {number} attachmentIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerGetAttachment(folder: WebmailPortalControllerGetAttachmentFolderEnum, uid: number, attachmentIndex: number, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerGetAttachment(folder, uid, attachmentIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerGetBodyAndAttachmentsFolderEnum} folder 
     * @param {number} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerGetBodyAndAttachments(folder: WebmailPortalControllerGetBodyAndAttachmentsFolderEnum, uid: number, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerGetBodyAndAttachments(folder, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerGetMessageCountFolderEnum} folder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerGetMessageCount(folder: WebmailPortalControllerGetMessageCountFolderEnum, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerGetMessageCount(folder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerGetMessagesFolderEnum} folder 
     * @param {number} start 
     * @param {number} maxNumberOfMessages 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerGetMessages(folder: WebmailPortalControllerGetMessagesFolderEnum, start: number, maxNumberOfMessages: number, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerGetMessages(folder, start, maxNumberOfMessages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerGetMimeMessageFolderEnum} folder 
     * @param {number} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerGetMimeMessage(folder: WebmailPortalControllerGetMimeMessageFolderEnum, uid: number, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerGetMimeMessage(folder, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerGetQuotaFolderEnum} folder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerGetQuota(folder: WebmailPortalControllerGetQuotaFolderEnum, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerGetQuota(folder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} recipient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerIsRecipientAllowed(recipient: string, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerIsRecipientAllowed(recipient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerReplyFolderEnum} folder 
     * @param {number} uid 
     * @param {string} textBody 
     * @param {Array<File>} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerReply(folder: WebmailPortalControllerReplyFolderEnum, uid: number, textBody: string, attachments?: Array<File>, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerReply(folder, uid, textBody, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subject 
     * @param {Array<string>} recipients 
     * @param {string} textBody 
     * @param {Array<File>} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerSendMail(subject: string, recipients: Array<string>, textBody: string, attachments?: Array<File>, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerSendMail(subject, recipients, textBody, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebmailPortalControllerSetReadFlagFolderEnum} folder 
     * @param {boolean} read 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebmailApi
     */
    public webmailPortalControllerSetReadFlag(folder: WebmailPortalControllerSetReadFlagFolderEnum, read: boolean, requestBody: Array<number>, options?: RawAxiosRequestConfig) {
        return WebmailApiFp(this.configuration).webmailPortalControllerSetReadFlag(folder, read, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const WebmailPortalControllerDeleteMessagesFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerDeleteMessagesFolderEnum = typeof WebmailPortalControllerDeleteMessagesFolderEnum[keyof typeof WebmailPortalControllerDeleteMessagesFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerGetAttachmentFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerGetAttachmentFolderEnum = typeof WebmailPortalControllerGetAttachmentFolderEnum[keyof typeof WebmailPortalControllerGetAttachmentFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerGetBodyAndAttachmentsFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerGetBodyAndAttachmentsFolderEnum = typeof WebmailPortalControllerGetBodyAndAttachmentsFolderEnum[keyof typeof WebmailPortalControllerGetBodyAndAttachmentsFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerGetMessageCountFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerGetMessageCountFolderEnum = typeof WebmailPortalControllerGetMessageCountFolderEnum[keyof typeof WebmailPortalControllerGetMessageCountFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerGetMessagesFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerGetMessagesFolderEnum = typeof WebmailPortalControllerGetMessagesFolderEnum[keyof typeof WebmailPortalControllerGetMessagesFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerGetMimeMessageFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerGetMimeMessageFolderEnum = typeof WebmailPortalControllerGetMimeMessageFolderEnum[keyof typeof WebmailPortalControllerGetMimeMessageFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerGetQuotaFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerGetQuotaFolderEnum = typeof WebmailPortalControllerGetQuotaFolderEnum[keyof typeof WebmailPortalControllerGetQuotaFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerReplyFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerReplyFolderEnum = typeof WebmailPortalControllerReplyFolderEnum[keyof typeof WebmailPortalControllerReplyFolderEnum];
/**
 * @export
 */
export const WebmailPortalControllerSetReadFlagFolderEnum = {
    Inbox: 'INBOX',
    Sent: 'SENT'
} as const;
export type WebmailPortalControllerSetReadFlagFolderEnum = typeof WebmailPortalControllerSetReadFlagFolderEnum[keyof typeof WebmailPortalControllerSetReadFlagFolderEnum];
